export default {
  namespaced: true,
  state: {
    drawer:false,
    tabs_item: [
      // The Dashboard group. Each board has its own access code,
      // `dashboard.<board>.view`, which checkForPermission() tests in place of
      // the title-based tab check.
      {
        id: 1,
        title: "Lead & App Journey",
        permission: "dashboard.funnel.view",
        url: { name: "dashboard-funnel" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 1,
        title: "Disbursement Journey",
        permission: "dashboard.disbursement.view",
        url: { name: "dashboard-disbursement" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 1,
        title: "Loan Book Journey",
        permission: "dashboard.books.view",
        url: { name: "dashboard-portfolio" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 1,
        title: "Collections Journey",
        permission: "dashboard.collections.view",
        url: { name: "dashboard-collections" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 1,
        title: "Old Dashboard",
        permission: "dashboard.old.view",
        url: { name: "dashboard-old" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 1,
        title: "Team",
        url: { name: "team" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 1,
        title: "Dealer",
        url: { name: "dealer" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 2,
        title: "Loan Schema",
        url: { name: "loan-scheme" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 2,
        title: "Delete Requests",
        url: { name: "delete-requests" },
        role: ["Admin", "Manager", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 3,
        title: "Leads",
        url: { name: "agent-los" },
        role: ["Admin", "Manager", "Tech-Support", "Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 3,
        title: "LOS",
        url: { name: "lead-list" },
        role: ["Admin", "Manager", "Tech-Support", "Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 5,
        title: "Disbursement",
        url: { name: "account-list" },
        role: ["Admin", "Tech-Support"],
        hierarchy_level: ["1"],
      },
      {
        id: 4,
        title: "LMS",
        url: { name: "lms-List" },
        role: ["Admin", "Manager", "Tech-Support", "Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 5,
        title: "Collection",
        url: { name: "collection-list" },
        role: ["Admin", "Manager", "Tech-Support", "Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 9,
        title: "NACH",
        url: { name: "nach-list" },
        role: ["Admin", "Manager", "Tech-Support", "Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 7,
        title: "Accounts",
        url: { name: "ledger-panel" },
        role: ["Admin", "Manager", "Tech-Support", "Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 7,
        title: "Payments",
        url: { name: "payments-panel" },
        role: ["Admin", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 7,
        title: "Reports",
        url: { name: "reports-panel" },
        role: ["Admin", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 7,
        title: "Notifications",
        url: { name: "notifications" },
        role: ["Admin", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      {
        id: 8,
        title: "Settings",
        url: { name: "settings" },
        role: ["Admin", "Tech-Support"],
        hierarchy_level: ["1", "2", "3"],
      },
      // {
      //   id: 6,
      //   title: "Notice Management",
      //   url: { name: "notice-management" },
      // },
      {
        id: 10,
        title: "User Sessions",
        url: { name: "session_history" },
        permission: "session_history.view",
      },
    ],
  },
  getters: {
    getDrawerTabs: (state) => state.tabs_item,
    getDrawer: (state) => state.drawer,
  },
  mutations: {
    SET_DRAWER(state,value){
    state.drawer = value !== undefined ? value : !state.drawer;

    }
  },
  actions: {
    setDrawer({ commit },value){
      commit("SET_DRAWER",value);
    },
  },
};
